import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes dudaba cada vez que tenía que medicar… ahora sé qué hacer.',
  name: 'Camila R.',
  role: 'Buenos Aires'
}, {
  quote: 'Me dio claridad en la práctica, sobre todo en situaciones reales.',
  name: 'Florencia M.',
  role: 'Córdoba'
}, {
  quote: 'Dejé de sentir que estaba improvisando con los medicamentos.',
  name: 'Lucía G.',
  role: 'Rosario'
}];
export function Testimonials() {
  return <section className="py-5 px-5 bg-brand-navy" data-id="element-272">
      <div className="max-w-xl mx-auto" data-id="element-273">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-274">
          💬 ¿Qué dicen quienes ya usan el Mega Pack?
        </h2>

        <div className="space-y-4" data-id="element-275">
          {testimonials.map((t, i) => <div key={i} className="bg-brand-blue-dark/30 border border-white/5 p-5 rounded-xl backdrop-blur-sm" data-id="element-276">
              <div className="flex gap-0.5 mb-3" data-id="element-277">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow bg-[#B1353500]" data-id="element-278" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-279">
                "{t.quote}"
              </p>
              <div data-id="element-280">
                <p className="font-bold text-white text-sm" data-id="element-281">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-282">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}